import React, { useState } from "react";
import { motion } from "framer-motion";
import ApexCharts from "react-apexcharts";
import './Card.css';

const Card = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [graphData, setGraphData] = useState(generateRandomData('sales')); 

  const handleCardClick = (cardType) => {
    setSelectedCard(cardType);
    setGraphData(generateRandomData(cardType)); 
    setIsModalOpen(true);
  };

  const modalBackgroundColors = {
    sales: "#ffbbc5", 
    revenue: "#88d6fa", 
    expenses: "#f7a9ea", 
  };

  return (
    <div className="card-container">
      <motion.div
        className="card sales"
        onClick={() => handleCardClick('sales')}
        initial={{ scale: 1 }}
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        <div className="card-title">Sales</div>
        <div className="card-content">
          <div className="circle-graph">
            <CircularProgressBar percentage={60} />
          </div>
          <div className="money-count">₹20,000</div>
        </div>
        <div className="last-24hours">Last 24 Hours</div>
      </motion.div>

      <motion.div
        className="card revenue"
        onClick={() => handleCardClick('revenue')}
        initial={{ scale: 1 }}
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        <div className="card-title">Revenue</div>
        <div className="card-content">
          <div className="circle-graph">
            <CircularProgressBar percentage={80} />
          </div>
          <div className="money-count">₹50,000</div>
        </div>
        <div className="last-24hours">Last 24 Hours</div>
      </motion.div>

      <motion.div
        className="card expenses"
        onClick={() => handleCardClick('expenses')}
        initial={{ scale: 1 }}
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        <div className="card-title">Expenses</div>
        <div className="card-content">
          <div className="circle-graph">
            <CircularProgressBar percentage={40} />
          </div>
          <div className="money-count">₹8,000</div>
        </div>
        <div className="last-24hours">Last 24 Hours</div>
      </motion.div>

      {isModalOpen && (
        <motion.div
          className="modal"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <div
            className="modal-body"
            style={{
              backgroundColor: modalBackgroundColors[selectedCard] || "#fff",
            }}
          >
            <h2>Total {selectedCard.charAt(0).toUpperCase() + selectedCard.slice(1)}</h2>
            <ApexCharts
              options={graphData.options}
              series={graphData.series}
              type="line"
              height={350}
            />
            <button className="modal-close-button" onClick={() => setIsModalOpen(false)}>
              Close
            </button>
          </div>
        </motion.div>
      )}
    </div>
  );
};

const CircularProgressBar = ({ percentage }) => {
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = `${(percentage / 100) * circumference} ${circumference}`;

  return (
    <div className="circle-container">
      <svg width="100" height="100">
        <circle cx="50" cy="50" r={radius} stroke="#ddd" strokeWidth="8" fill="none" />
        <circle
          cx="50"
          cy="50"
          r={radius}
          stroke="#4caf50"
          strokeWidth="8"
          fill="none"
          strokeDasharray={strokeDasharray}
          strokeDashoffset="0"
        />
      </svg>
      <div className="percentage-text">{percentage}%</div>
    </div>
  );
};

const generateRandomData = (cardType) => {
  const options = {
    chart: {
      id: "line-chart",
    },
    xaxis: {
      categories: ["00:00", "06:00", "12:00", "18:00", "24:00"],
    },
    stroke: {
      curve: "smooth",
    },
  };

  let series;
  if (cardType === 'sales') {
    series = [
      { name: "Sales", data: Array.from({ length: 5 }, () => Math.floor(Math.random() * 100)) },
    ];
  } else if (cardType === 'revenue') {
    series = [
      { name: "Revenue", data: Array.from({ length: 5 }, () => Math.floor(Math.random() * 100)) },
    ];
  } else if (cardType === 'expenses') {
    series = [
      { name: "Expenses", data: Array.from({ length: 5 }, () => Math.floor(Math.random() * 100)) },
    ];
  }

  return { options, series };
};

export default Card;
